import { cn } from "@/lib/utils";
import React from "react";

const MarketingCard = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "tw-rounded-4 tw-border tw-border-gray-300 tw-bg-base-white tw-p-16 tw-w-full tw-flex tw-flex-col",
      className,
    )}
    {...props}
  />
));
MarketingCard.displayName = "MarketingCard";

const MarketingCardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("tw-flex tw-flex-col tw-gap-4 tw-mb-4", className)}
    {...props}
  />
));
MarketingCardHeader.displayName = "MarketingCardHeader";

const MarketingCardTitle = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn("tw-headline-1-m tw-text-gray-900 tw-m-0", className)}
    {...props}
  />
));
MarketingCardTitle.displayName = "MarketingCardTitle";

const MarketingCardDescription = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("tw-body-2 tw-text-gray-600", className)}
    {...props}
  />
));
MarketingCardDescription.displayName = "MarketingCardDescription";

const MarketingCardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("tw-body-1-long tw-text-gray-600 tw-m-0", className)}
    {...props}
  />
));
MarketingCardContent.displayName = "MarketingCardContent";

const MarketingCardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("tw-pt-8 tw-mt-auto", className)} {...props} />
));
MarketingCardFooter.displayName = "MarketingCardFooter";

export {
  MarketingCard,
  MarketingCardContent,
  MarketingCardDescription,
  MarketingCardFooter,
  MarketingCardHeader,
  MarketingCardTitle,
};
